(() => {
  // app/scripts/form-reseller-certificate.js
  var FormResellerCertificate = class extends HTMLElement {
    constructor() {
      super();
    }
    connectedCallback() {
      this.form = this.querySelector("form");
      this.type = this.getAttribute("type");
      this.formAPI = this.getAttribute("form-api");
      this.formSuccess = this.querySelector(".form-success");
      this.formError = this.querySelector(".form-error");
      this.btnSubmitText = this.form.querySelector(".btn-submit-text");
      this.btnLoading = this.querySelector(".loading-submit");
      this.submitBtn = this.querySelector('button[type="submit"]');
      this.closeModalBtn = this.querySelector(".close-modal");
      this.overlay = this.querySelector(".overlay-form");
      this.form.addEventListener("submit", (e) => this.handleSubmitForm(e));
      this.closeModal();
      this.autofillDate();
    }
    autofillDate() {
      const dateInput = this.form.querySelector('input[name="date"]');
      if (dateInput && !dateInput.value) {
        const today = /* @__PURE__ */ new Date();
        const yyyy = today.getFullYear();
        const mm = String(today.getMonth() + 1).padStart(2, "0");
        const dd = String(today.getDate()).padStart(2, "0");
        dateInput.value = `${yyyy}-${mm}-${dd}`;
      }
    }
    // State loading
    loadingState(isLoading) {
      if (!this.btnLoading || !this.btnSubmitText)
        return;
      this.submitBtn.disabled = isLoading;
      if (isLoading) {
        this.btnLoading.classList.remove("hidden");
        this.btnSubmitText.classList.add("hidden");
      } else {
        this.btnLoading.classList.add("hidden");
        this.btnSubmitText.classList.remove("hidden");
      }
    }
    //Close form success
    closeModal() {
      if (this.closeModalBtn) {
        this.closeModalBtn.addEventListener("click", () => this.hideSuccess());
      }
      if (this.overlay) {
        this.overlay.addEventListener("click", () => this.hideSuccess());
      }
    }
    //Show form success
    showSuccess() {
      if (!this.formSuccess)
        return;
      this.formSuccess.classList.remove("hidden");
    }
    //Hide form success
    hideSuccess() {
      if (!this.formSuccess)
        return;
      this.formSuccess.classList.add("hidden");
    }
    // Show error form
    showError() {
      if (!this.formError)
        return;
      this.formError.classList.remove("hidden");
    }
    async handleSubmitForm(e) {
      e.preventDefault();
      const formData = new FormData(this.form);
      const fields = Array.from(formData.entries()).map(([key, value]) => ({
        key,
        value
      }));
      const body = {
        fields,
        type: this.type
      };
      this.loadingState(true);
      try {
        const res = await fetch(this.formAPI, {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Accept: "application/json"
          },
          body: JSON.stringify(body)
        });
        if (!res.ok) {
          const errorText = await res.text();
          throw new Error(
            `Request failed with status ${res.status}: ${errorText}`
          );
        }
        this.showSuccess();
        this.form.reset();
        this.autofillDate();
      } catch (error) {
        console.error("Form submission error:", error);
        this.showError();
      } finally {
        this.loadingState(false);
      }
    }
  };
  customElements.define("form-reseller-certificate", FormResellerCertificate);
})();
